import { Modal } from 'antd';
import { AxiosError } from 'axios';

interface ApiErrorResponse {
  code?: string;
  message?: string;
}

let isInactiveAccountModalOpen = false;

export const handleInactiveAccount = (error: AxiosError): boolean => {
  const data = error.response?.data as ApiErrorResponse | undefined;

  if (error.response?.status !== 403 || data?.code !== 'ACCOUNT_INACTIVE') {
    return false;
  }

  if (!isInactiveAccountModalOpen) {
    isInactiveAccountModalOpen = true;

    Modal.error({
      title: 'Внимание',
      content: data.message || 'Ваш аккаунт был деактивирован.',
      okText: 'Понятно',
      onOk: () => {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        window.location.reload();
      },
    });
  }

  return true;
};
